export default "__VITE_ASSET__eac7546d__"